import * as Yup from "yup";

export const PROPERTY_VALIDATION_SCHEMA = Yup.object().shape({
  address: Yup.object({
    street: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    // .matches(/^[A-Z]{3,3}$/, 'city not valid'),
    subdivision: Yup.string()
      .required("Required")
      .matches(/^[A-Z]{2,2}-[A-Z]{2,2}$/, "subdivision not valid"),
    postalCode: Yup.string().required("Required"),
    country: Yup.string()
      .required("Required")
      .matches(/^[A-Z]{3,3}$/, "subdivision not valid"),
  }),
  additionalPetsInBuilding: Yup.string().required("Required"),
  additionalInformationMarkdown: Yup.string().required("Required"),
});

export const LEASE_VALIDATION_SCHEMA = Yup.object().shape({
  sublettingAvailable: Yup.string().required("Required"),
  // leaseRenewal: Yup.string().required('Required'),
  daysGuestsAllowed: Yup.string().required("Required"),
  // quietHours: Yup.string().required('Required'),
  proofOfRentalInsurance: Yup.string().required("Required"),
  tenantScreening: Yup.string().required("Required"),
  // creditCheck: Yup.string().required('Required'),
  // addendums: Yup.string().required('Required'),
});

export const EVERYTHING_FORM = Yup.object().shape({
  property: PROPERTY_VALIDATION_SCHEMA,
  lease: LEASE_VALIDATION_SCHEMA,
});

export const UNIT_VALIDATION_SCHEMA = Yup.object().shape({
  number: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
  floorLevel: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
  section8Approved: Yup.string().required("Required"),
  numberOfBedrooms: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
  numberOfBathrooms: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
  numberOfOtherRooms: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
  numberOfParkingSpots: Yup.number()
    .min(0, "Must be greater than or equal to 0")
    .required("Required"),
});

export const UNIT_LEASE_SETTINGS_VALIDATION_SCHEMA = Yup.object().shape({
  pets: Yup.string().required("Required"),
});

export const EVERYTHING_UNIT_FORM = Yup.object().shape({
  unit: UNIT_VALIDATION_SCHEMA,
  unitLeaseSettings: UNIT_LEASE_SETTINGS_VALIDATION_SCHEMA,
});

export const LIST_VALIDATION_SCHEMA = Yup.object().shape({
  photoUrls: Yup.array().required("Required").min(1),
  // ratings: Yup.object({
  //   buildingLoudness: Yup.string().required("Required"),
  //   feltSafeInsideBuilding: Yup.string().required("Required"),
  //   feltSafeOutsideBuilding: Yup.string().required("Required"),
  //   responsiveLandlord: Yup.string().required("Required"),
  //   cleanCommonAreasInside: Yup.string().required("Required"),
  //   cleanWellMaintainedPropertyOutside: Yup.string().required("Required"),
  //   waterPressure: Yup.string().required("Required"),
  //   overallLivingExperience: Yup.string().required("Required"),
  // }),
});

export const INVITE_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
});

export const APPLY_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  emailConfirmation: Yup.string().oneOf(
    [Yup.ref("email"), null],
    "Emails must match"
  ),
  agreement: Yup.bool().oneOf(
    [true],
    "You must accept the terms and conditions"
  ),
});
